// eslint-disable-next-line import/prefer-default-export
export const ORDER_TYPES = {
  basic: 'basic',
  maintain: 'maintain',
  per_hour: 'per_hour',
  office: 'office',
  spring_cleaning: 'spring_cleaning',
  after_repair: 'after_repair',
  dry_cleaning: 'dry_cleaning',
  windows: 'windows',
  after_the_fire: 'after_the_fire',
  sewerage: 'sewerage',
  office_b2b: 'office_b2b',
  remake: 'remake',
  wfp: 'wfp',
  armored_film: 'armored_film'
};
